module.exports = __webpack_public_path__ + "static/img/Page of Swords.756a4d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Page of Swords.jpg
// module id = 1289
// module chunks = 0